import { useCallback } from 'react';
import { useDexResults } from '../results/use-dex-results';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function useResetDexNextResultsStoreInitialFrFields() {
    const { dexResultsStore } = useDexResults();
    const { isFirstResponder } = useApplicationType();

    const resetDexNextResultsStoreInitialFrFields = useCallback(() => {
        if (!isFirstResponder) {
            return;
        }

        if (dexResultsStore.frDexNextPrefillValues) {
            dexResultsStore.setFrNextPrefillValues(undefined);
        }
    }, [dexResultsStore, isFirstResponder]);

    return { resetDexNextResultsStoreInitialFrFields };
}
